import React from 'react';
import { Link } from 'react-router-dom';


const EventSecurity = () => {
    return (
        <>
            {/* <!-- Breadcromb Area Start --> */}
            <section className="bleezy-breadcromb-area">
                <div className="breadcromb-top event-security-header">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-top-text">
                                    <h2 className="banner-heading">Event Security</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcromb-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-bottom-text">
                                    <ul>
                                        <li><Link to="/">home</Link></li>
                                        <li><a href="#"><i className="fa fa-long-arrow-right"></i></a></li>
                                        <li>Event Security</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Breadcromb Area End --> */}

            <section class="bleezy-blog-page-area" style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                <div class="container">
                    <div class="mid-title  mb-5 "><h2 class="heading-with-border"><strong>Event Security</strong></h2>
                        <h3 className="sub-heading-page sub-heading-m-t-15"><strong>Looking for Quick Short Term Security Services for an event in India?</strong></h3>
                        <h3 className="sub-heading-page sub-heading-m-b-15 heading-other-color"><strong>Contact us for an immediate response.</strong></h3>
                        <p className="octo-para">
                            Octopuss Security provides tailor made security solutions combining electronic gadgetry and security personnel. We have successfully covered events like IPL, Pro Kabaddi, Movies Premiere, Beauty Pageants, Concerts, Live Shows, TV Shows, Award Ceremonies, Fashion Shows, Beer and Wine Festival, Product Launch, Corporate Events, Marriages, Private Parties, Destination Weddings and every such events whether big or small.
                        </p>

                        <h3 className="sub-heading-page sub-heading-m-t-15 "><strong>Octopuss Security – For all your event needs</strong></h3>
                        <h3 className="sub-heading-page sub-heading-m-b-15 heading-other-color"><strong>Why are we most preferred event security management company in India?</strong></h3>


                        <p className="octo-para" style={{ marginTop: '18px' }}>
                            We have a completely fresh and unique approach to handling security for events in India. We understand what it takes to secure the event and make it a grand success. When you hire event security from other companies, usually you would be provided with manpower without taking care of ground level activity and thereby forcing you to handle, give instructions, coordinate and monitor the entire event. In our case, our work does not end by just allotting you required personnel, we will ensure that your event is handled professionally and smoothly by allotting you an assignment manager. Our Assignment Manager will take care of all ground level activity from commencement to conclusion and will be your single point of contact for your entire event.

                        </p>


                        <h3 className="sub-heading-page sub-heading-m-t-15 sub-heading-m-b-15"><strong>Security for events in India</strong></h3>
                        <p className="octo-para">
                            We have experienced, trained and professional male and female bouncers, security officers and close protection officers to take care of your every event needs. We offer flexibility to appoint as many as you want based on your daily or hourly requirement. We provide range of services to suit your event requirement.
                        </p>

                        <h4 className="sub-heading3-page sub-heading-m-t-15 sub-heading-m-b-15"><strong>You can hire following category of staff for your event</strong></h4>
                        <ul class="list">
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Event Staff such as anchors, guest greeters, exhibition attendants, etc.</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Traffic warden</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Escort guards for pick up and drop of female staff/guest</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Male and Female Bouncers</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Close Protection Officers</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Male and Female Guards with option of ceremonial uniform</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Dog Squad</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Gadgets such as metal detector, walkie talkie, alcohol tester for drivers, body temperature checker, etc.</li>
                        </ul>


                        <h3 className="sub-heading-page sub-heading-m-t-15 sub-heading-m-b-15"><strong>How to hire security for event?</strong></h3>
                        <p className="octo-para">
                            The process is very easy. You can book the service over a call or an email. Give us your requirement and get quotation from us within two hours. Once approved, our team would take care of the rest.
                        </p>
                    </div>
                </div>
            </section>


        </>
    )
}

export default EventSecurity;
